export default IconGymnastics => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-gymnastics" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M7 7a1 1 0 1 0 2 0a1 1 0 0 0 -2 0" />
  <path d="M13 21l1 -9l7 -6" />
  <path d="M3 11h6l5 1" />
  <path d="M11.5 8.5l4.5 -3.5" />
</svg>`;